import ctl from '@netlify/classnames-template-literals'

export function useInvisibleInput() {
	return ctl(`								
        border-none border-transparent 
        focus:border-transparent 
        focus-visible:border-transparent
        focus:outline-none
        focus-visible:outline-none
		focus-visible:ring-0
		focus:ring-0
    `)
}
